module.exports = __webpack_public_path__ + "img/Icon-material-first-page-black.dd043f68.svg";